import { Button } from '@salt/components';
import React from 'react';

import warningIcon from '../../media/icons/warning.svg';
import copyIcon from '../../media/icons/copy.svg';

const InviteLinkInfoModal = ({ handleInviteLinkInfoModalClose, inviteLinkOpen }) => {
  return (
    <div id="dialog" className="overlay z-[100] fixed top-0 left-0 m-auto w-full h-full flex">
      <button
        type="button"
        className="fixed w-full h-full z-[99] bg-black/30"
        onClick={handleInviteLinkInfoModalClose}
      />
      <div className="z-[100] w-[583px] react-modal small bg-secondary-light px-8 py-7 bg-white m-auto rounded-lg">
        <div className="text-lg mb-4">User Successfully Invited</div>
        <span className="text-base">
          In order for this user to onboard they must use the below link to set up a password for
          their account. Please copy and share this link.
        </span>
        <div className="bg-[#FFD600]/10 border border-[#FFD600] rounded-lg flex my-4 text-base text-[#E4A511] py-2 px-3">
          <img className="w-[17px] mr-4 mb-auto mt-1" src={warningIcon} alt="" />
          <div>
            <span className="block">
              This onboarding link will not be available after you close this dialog.
            </span>
            <span className="block font-bold">This link will also expire after 1 hour.</span>
          </div>
        </div>
        <div className="text-lg mb-4">Onboarding Link</div>
        <div className="bg-[#F9FAFC] flex py-2 px-4 rounded-sm items-center justify-center">
          <img className="mr-4" src={copyIcon} alt="" />
          <div className="text-base truncate mx-2">{inviteLinkOpen}</div>
          <Button
            onClick={() => navigator.clipboard.writeText(inviteLinkOpen)}
            type="neutral"
            className="max-w-[75px] h-[36px] ml-auto"
            paddingClassName="px-6"
          >
            Copy
          </Button>
        </div>
        <div className="mt-4">
          <br />
          <Button
            onClick={handleInviteLinkInfoModalClose}
            type="neutral"
            className="max-w-[146px] h-[36px] ml-auto"
            paddingClassName="px-6"
          >
            Cancel
          </Button>
          <Button
            onClick={handleInviteLinkInfoModalClose}
            type="positive"
            className="max-w-[146px] h-[36px] ml-auto float-right"
            paddingClassName="px-6"
          >
            Done
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InviteLinkInfoModal;
